import { jsx as _jsx } from "react/jsx-runtime";
import { leadinPluginVersion, pluginPath } from '../../constants/leadinConfig';
import { useRefEffect } from '@wordpress/compose';
function StylesheetErrorBondary({ children }) {
    const ref = useRefEffect(element => {
        const { ownerDocument } = element;
        if (ownerDocument &&
            !ownerDocument.getElementById('leadin-gutenberg-css')) {
            const link = ownerDocument.createElement('link');
            link.id = 'leadin-gutenberg-css';
            link.rel = 'stylesheet';
            link.href = `${pluginPath}/build/gutenberg.css?ver=${leadinPluginVersion}`;
            ownerDocument.head.appendChild(link);
        }
    }, []);
    return _jsx("div", { ref: ref, children: children });
}
export default StylesheetErrorBondary;
